import store from "../store/store";

function prepFilter(query, activeFilter) {
  let selection = [];

  if (query.length > 0 || query._id) {
    selection.push(query);
  }

  // Add ACTIVATED filter
  if (activeFilter) {
    if (selection.length > 0) {
      selection.push("AND", "_id" in activeFilter? activeFilter:activeFilter.rawquery);
    } else {
      selection.push(activeFilter);
    }
  }

  selection = filterOutIdName(selection);
  return selection;
}

function filterOutIdName(selection) {
  if (!Array.isArray(selection)) {
    if (typeof selection === "string") {
      // Operator
      return selection;
    }
    return { _id: selection._id, name: selection.name };
  } else {
    let res = [];
    selection.forEach(sel => {
      res.push(filterOutIdName(sel));
    });
    return res;
  }
}

function getParentId(categories, id) {
  let theFilt = {};
  categories.forEach(cat => {
    cat.children.forEach(subcat => {
      subcat.children.forEach(filt => {
        if (filt._id === id) {
          theFilt = {
            filt: filt._id,
            subCat: subcat._id,
            cat: cat._id
          };
        }
      });
    });
  });
  return theFilt;
}

async function getFiltId(filters, name) {
  return new Promise((resolve, reject) => {
    let categories = filters;
    if(!categories){
      categories = store.state.filter.filters;
    }
    let theFilt = null;
    if(categories.length > 0){
      categories.forEach((cat, c) => {
        if(cat.name === name){
          theFilt = {
            id: cat._id,
            ind: c
          }
        }
        else{
          cat.children.forEach((sub, s) => {
            if(sub.name === name){
              theFilt = {
                id: sub._id,
                cat: cat._id,
                c_ind: c,
                ind: s
              }
            }
            else{
              sub.children.forEach((filt, f) => {
                if(filt.name === name){
                  theFilt = {
                    id: filt._id,
                    cat: cat._id,
                    sub: sub._id,
                    c_ind: c,
                    s_ind: s,
                    ind: f
                  }
                }   
              })
            }   
          })
        }
        if(categories.length === c+1){
          resolve(theFilt);
        }
      });
    }
    else{
      resolve(theFilt);
    }
  })
}

async function getMemberFilters(cats, group) {
  return new Promise((resolve, reject) => {
    let categories = cats;
    if(!categories){
      categories = store.state.filter.filters;
    }
    let theFilt = [];
    if(group === "filtergroup"){
      let items = [];
      categories.forEach((cat, n) => {
        if(cat.name !== "tempmaincat"){
          cat.children.forEach((sub) => {
            sub.children.forEach((filt, f) => {
              if(!(filt._id.includes("invalid")) && !(filt.name.includes("_del"))){
                items.push({ "_id": filt._id });
                items.push("OR");
              }
            });
          });
          items.pop();
          if(items.length > 0){
            theFilt.push({ "label": "Cat:"+cat.name, "items":items });
          }
          items = [];
        }
        if(categories.length === n+1){
          resolve(theFilt);
        }  
      });
    }
    else {
      let items = [];
      categories.forEach((cat, n) => {
        if(cat.name !== "tempmaincat"){
          cat.children.forEach((sub) => {
            sub.children.forEach((filt) => {
              if(!(filt._id.includes("invalid")) && !(filt.name.includes("_del"))){
                items.push({ "_id": filt._id });
                items.push("OR");
              }
            });
            items.pop();
            if(items.length > 0){
              theFilt.push({ "label": "Subcat:"+sub.name, "items":items });
            }
            items = [];
          });
        }
        if(categories.length === n+1){
          resolve(theFilt);
        } 
      });
    }
  })
}

function preFilter(query, validity=true) {
  let res = [];
  let left = [...query];
  while (left.length > 0) {
    let item = left.shift();
    if (
      item.type === "operator" ||
      item.value === "bracket_open" ||
      item.value === "bracket_close"
    ) {
      if (item.value === "bracket_open") {
        // start nest
        let cnt = 1;
        let ix;
        // Find matching bracket
        for (ix = 0; ix < left.length; ix++) {
          let it = left[ix];
          if (it.value === "bracket_close") {
            cnt -= 1;
          } else if (it.value === "bracket_open") {
            cnt += 1;
          }
          if (cnt === 0) {
            break;
          }
        }
        let sub = left.slice(0, ix+1);
        left = left.slice(ix+1);
        res.push(preFilter(sub));
      } else if (item.value === "bracket_close") {
        // Return
        return res;
      } else {
        // Operator
        res.push(item.value);
      }
    } else {
      let orFilt = [];
      if (Array.isArray(item.value)) {
        item.value.forEach((_id, c) => {
          !validity? orFilt.push({ _id: _id, type: "Concept", name: item.info[c] }, "OR"):orFilt.push({ _id: _id, type: "Concept", name: item.info[c] }, "OR");
        });
        orFilt.pop();
        // if (orFilt.length === 1) {
        //   orFilt = orFilt[0];
        // }
        res.push(orFilt);
      } else {
        !validity? res.push([{ _id: item.value, type: "Concept", name: item.info[0] }]):res.push([{ _id: item.value, type: "Concept", name: item.info[0] }]);
      }
    }
  }
  if (res.length === 1) {
    return res[0];
  } else {
    return res;
  }
}
/*
     * Converts Selected Element(s) to a name and a correct filter. Selected elements are received in an object
     * (single item) or as an array multiple elements. In the latter case:
     * [A, B, C, ...] => Will be converted to [A, "OR", B, "OR", C, "OR", ...]
     * where A, B, C, ... are arrays of objects. The objects in these arrays are combined with "AND"
     * A => [{obj}, "AND", {obj}, "AND", {obj}, ...]
     * @returns {{fName: *, filt: []}}
*/
function parseSelectedElements(element) {
  let filt = [],
    name = [];
  if (Array.isArray(element)) {
    // Multiple selected elements => They will be joined by "OR", inner elements are joined by "AND"
    element.forEach(el => {
      let flatAnd = _.flatten(el);
      let fName = flatAnd.map(x => x.name).join(" AND ");
      let fFilt = flatAnd.map(x => {
        return [x, "AND"];
      });
      fFilt = _.flatten(fFilt);
      fFilt.pop(); // Remove Final "AND"
      if (fFilt.length === 1) {
        fFilt = fFilt[0];
      }
      filt.push(fFilt, "OR");
      name.push(fName);
    });
    filt.pop(); // Remove final "OR"

    if (filt.length === 1) {
      filt = filt[0];
    }

    // Naming
    if (name.length > 1) {
      name = name.map(x => "(" + x + ")").join(" OR ");
    } else {
      name = name[0];
    }
  } else {
    // Only one element
    filt = {
      _id: "_id" in element ? element._id : element.id,
      type: element.type,
      name: element.name
    };
    name = element.name;
  }

  return { filt: filt, name: name };
}


function addCounts(imported) {
  let newImports = imported;
  newImports.categories.forEach((cat) => {
    cat.children.forEach((sub) => {
      sub.children.forEach((filt) => {
        let matched = 0;
        let unmatched = 0;
        filt.rawquery.forEach((q) => {
          if (q !== "OR") {
            q._id === "TTC_XXX" ? (unmatched += 1) : (matched += 1);
          }
        });
        filt.matched = matched;
        filt.unmatched = unmatched;
      });
    });
  });
  return newImports;
}

export { preFilter, prepFilter, filterOutIdName, getParentId, getFiltId, getMemberFilters, parseSelectedElements, addCounts };
